import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/points-of-sale/devices')({
	staticData: {
		crumb: ({ context: { L } }) => L.Settings.Devices.Title()
	}
})
